// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brokerRating-container {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  box-sizing: border-box;
  container-type: inline-size;
  width: 100%;
  min-width: 328px;
  height: 100%;
}

.brokerRating {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.brokerRating-card-potential-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.brokerRating-info-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--text-primary);
}

.brokerRating-info-button svg {
  width: 100%;
  height: 100%;
  display: block;
}

.brokerRating-card-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 2px;
  background-color: var(--surface-tertiary);
}

.brokerRating-card-header {
  align-items: center;
  text-align: center;
}

.brokerRating-card-icon {
  width: 20px;
  height: 20px;

  path {
    fill: var(--accent-primary) !important;
  }
}

.brokerRating-card-content.strongBuy {
  --broker-icon-color: var(--heatmap-up-5);
}

.brokerRating-card-content.buy {
  --broker-icon-color: var(--heatmap-up-2);
}

.brokerRating-card-content.hold {
  --broker-icon-color: var(--accent-secondary);
}

.brokerRating-card-content.reduce {
  --broker-icon-color: var(--heatmap-down-3);
}

.brokerRating-card-content.sell {
  --broker-icon-color: var(--heatmap-down-5);
}

.brokerRating-card-content {
  padding-top: 20px;
  gap: 8px;
}

.brokerRating-card-recommendation-container {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 3px 12px;
  border-radius: 1px;
  justify-content: center;
  height: 56px;
  background-color: var(--heatmap-no-chg);
  color: var(--text-primary);
}

.brokerRating-card-header .strongBuy {
  background-color: var(--heatmap-up-5);
  color: var(--text-invert);
}

.brokerRating-card-header .buy {
  background-color: var(--heatmap-up-2);
  color: var(--text-invert);
}

.brokerRating-card-header .hold {
  background-color: var(--heatmap-no-chg);
  color: var(--text-primary);
}

.brokerRating-card-header .reduce {
  background-color: var(--heatmap-down-3);
  color: var(--text-invert);
}

.brokerRating-card-header .sell {
  background-color: var(--heatmap-down-5);
  color: var(--text-invert);
}

.brokerRating-card-recommendation {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
}

.brokerRating-card-description {
  padding-top: 16px;
  align-self: center;
  text-align: left;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: var(--text-primary);
}

.brokerRating-chart-group {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.brokerRating-card-potential {
  display: flex;
  align-items: end;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  color: var(--text-primary);
}
@container (max-width: 719px) {
  .brokerRating-chart-wrapper {
    margin-top: -50px;
  }
}
@container (min-width: 720px) {
  .brokerRating-card-container {
    flex-direction: row;
    gap: 24px;
  }

  .brokerRating-card-content {
    padding-top: 6px;
    margin-left: -12px;
  }

  .brokerRating-card-recommendation-container {
    max-width: 328px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .brokerRating-chart-group {
    flex-direction: row;
    gap: 24px;
    padding-top: 16px;
    margin-top: -8px;
    align-items: center;
    padding-right: 0px;
  }

  .brokerRating-table-wrapper {
    flex: 0 0 336px;
    max-width: 336px;
  }

  .brokerRating-chart-wrapper {
    flex: 1;
    min-width: 0;
    margin-left: -16px;
    margin-right: 0px;
  }
}
@container (min-width: 1024px) {
  .brokerRating {
    flex-direction: row;
    align-items: flex-start;
    gap: 32px;
  }

  .brokerRating-card-container {
    flex-direction: column;
    flex: 0 0 336px;
    width: 336px;
  }

  .brokerRating-card-content {
    padding-top: 16px;
    margin-left: 0;
  }

  .brokerRating-chart-group {
    flex-direction: row;
    flex: 1;
    gap: 32px;
    width: 100%;
    margin-top: -20px;
    padding-top: 0px;

    align-items: flex-start;
  }

  .brokerRating-table-wrapper {
    flex: 0 0 auto;
    max-width: none;
    margin-bottom: 0;
  }

  .brokerRating-chart-wrapper {
    flex: 1;
    min-width: 0;
    margin-right: 0px;
    margin-left: 0px;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/BrokerRatingWidget/BrokerRatingWidget.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,OAAO;IACP,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,gBAAgB;;IAEhB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".brokerRating-container {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  box-sizing: border-box;\n  container-type: inline-size;\n  width: 100%;\n  min-width: 328px;\n  height: 100%;\n}\n\n.brokerRating {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.brokerRating-card-potential-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.brokerRating-info-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: var(--text-primary);\n}\n\n.brokerRating-info-button svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.brokerRating-card-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 24px;\n  border-radius: 2px;\n  background-color: var(--surface-tertiary);\n}\n\n.brokerRating-card-header {\n  align-items: center;\n  text-align: center;\n}\n\n.brokerRating-card-icon {\n  width: 20px;\n  height: 20px;\n\n  path {\n    fill: var(--accent-primary) !important;\n  }\n}\n\n.brokerRating-card-content.strongBuy {\n  --broker-icon-color: var(--heatmap-up-5);\n}\n\n.brokerRating-card-content.buy {\n  --broker-icon-color: var(--heatmap-up-2);\n}\n\n.brokerRating-card-content.hold {\n  --broker-icon-color: var(--accent-secondary);\n}\n\n.brokerRating-card-content.reduce {\n  --broker-icon-color: var(--heatmap-down-3);\n}\n\n.brokerRating-card-content.sell {\n  --broker-icon-color: var(--heatmap-down-5);\n}\n\n.brokerRating-card-content {\n  padding-top: 20px;\n  gap: 8px;\n}\n\n.brokerRating-card-recommendation-container {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  padding: 3px 12px;\n  border-radius: 1px;\n  justify-content: center;\n  height: 56px;\n  background-color: var(--heatmap-no-chg);\n  color: var(--text-primary);\n}\n\n.brokerRating-card-header .strongBuy {\n  background-color: var(--heatmap-up-5);\n  color: var(--text-invert);\n}\n\n.brokerRating-card-header .buy {\n  background-color: var(--heatmap-up-2);\n  color: var(--text-invert);\n}\n\n.brokerRating-card-header .hold {\n  background-color: var(--heatmap-no-chg);\n  color: var(--text-primary);\n}\n\n.brokerRating-card-header .reduce {\n  background-color: var(--heatmap-down-3);\n  color: var(--text-invert);\n}\n\n.brokerRating-card-header .sell {\n  background-color: var(--heatmap-down-5);\n  color: var(--text-invert);\n}\n\n.brokerRating-card-recommendation {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 24px;\n}\n\n.brokerRating-card-description {\n  padding-top: 16px;\n  align-self: center;\n  text-align: left;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0px;\n  color: var(--text-primary);\n}\n\n.brokerRating-chart-group {\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n}\n\n.brokerRating-card-potential {\n  display: flex;\n  align-items: end;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  color: var(--text-primary);\n}\n@container (max-width: 719px) {\n  .brokerRating-chart-wrapper {\n    margin-top: -50px;\n  }\n}\n@container (min-width: 720px) {\n  .brokerRating-card-container {\n    flex-direction: row;\n    gap: 24px;\n  }\n\n  .brokerRating-card-content {\n    padding-top: 6px;\n    margin-left: -12px;\n  }\n\n  .brokerRating-card-recommendation-container {\n    max-width: 328px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .brokerRating-chart-group {\n    flex-direction: row;\n    gap: 24px;\n    padding-top: 16px;\n    margin-top: -8px;\n    align-items: center;\n    padding-right: 0px;\n  }\n\n  .brokerRating-table-wrapper {\n    flex: 0 0 336px;\n    max-width: 336px;\n  }\n\n  .brokerRating-chart-wrapper {\n    flex: 1;\n    min-width: 0;\n    margin-left: -16px;\n    margin-right: 0px;\n  }\n}\n@container (min-width: 1024px) {\n  .brokerRating {\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 32px;\n  }\n\n  .brokerRating-card-container {\n    flex-direction: column;\n    flex: 0 0 336px;\n    width: 336px;\n  }\n\n  .brokerRating-card-content {\n    padding-top: 16px;\n    margin-left: 0;\n  }\n\n  .brokerRating-chart-group {\n    flex-direction: row;\n    flex: 1;\n    gap: 32px;\n    width: 100%;\n    margin-top: -20px;\n    padding-top: 0px;\n\n    align-items: flex-start;\n  }\n\n  .brokerRating-table-wrapper {\n    flex: 0 0 auto;\n    max-width: none;\n    margin-bottom: 0;\n  }\n\n  .brokerRating-chart-wrapper {\n    flex: 1;\n    min-width: 0;\n    margin-right: 0px;\n    margin-left: 0px;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
